module.exports = __webpack_public_path__ + "img/spinner.59460e3c.gif";